import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classNames from 'classnames';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import property from 'lodash/property';

import { Button, Text, Box } from '@nerdwallet/currency';
import nds from '@nerdwallet/base-styles/classes';

import parseMdlinks from '../../lib/parse-md-links';
import { stringInputSpec } from '../../lib/editing-configs';

const TableFooter = ({
  className,
  tableFooterButtonText,
  tableFooterButtonLink,
  tableFooterSubText,
  tableFooterSubTextLink,
  size,
}) => {
  const button = tableFooterButtonText && tableFooterButtonLink;
  const subText = tableFooterSubText && tableFooterSubTextLink;

  return button || subText ? (
    <div className={className} data-size={size}>
      <div
        className={classNames([
          nds('padding-top-2'),
          nds('padding-top-3--wide'),
          {
            [nds('display-flex--wide', 'justify-content-space-between--wide')]:
              size === 'lg',
          },
        ])}
      >
        {subText && (
          <Box
            className={classNames([
              'tableFooter__sub-text',
              {
                [nds('padding-bottom-3')]: size === 'lg' || subText,
              },
            ])}
          >
            <Text size="small">
              {parseMdlinks(
                `[${tableFooterSubText}](${tableFooterSubTextLink})`
              )}
            </Text>
          </Box>
        )}
        {button && (
          <Button
            href={tableFooterButtonLink}
            target="_blank"
            className="tableFooter__button"
          >
            {tableFooterButtonText}
          </Button>
        )}
      </div>
    </div>
  ) : null;
};

TableFooter.propTypes = {
  className: PropTypes.string,
  tableFooterButtonText: PropTypes.string,
  tableFooterButtonLink: PropTypes.string,
  tableFooterSubText: PropTypes.string,
  tableFooterSubTextLink: PropTypes.string,
  size: PropTypes.string,
};

TableFooter.defaultProps = {
  className: '',
};

TableFooter.getEditingConfig = () => [
  stringInputSpec('tableFooterButtonText', 'Table Footer Button Text'),
  stringInputSpec('tableFooterButtonLink', 'Table Footer Button Link'),
  stringInputSpec('tableFooterSubText', 'Table Footer Sub Text'),
  stringInputSpec('tableFooterSubTextLink', 'Table Footer Sub Text Link'),
];

TableFooter.displayName = 'TableFooter';

export default connect(
  createStructuredSelector({
    size: property('mediaQuery'),
  })
)(TableFooter);
